export default {
  FETCH_FEATURE_TOGGLES_START: 'FETCH_FEATURE_TOGGLES_START',
  FETCH_FEATURE_TOGGLES_SUCCESS: 'FETCH_FEATURE_TOGGLES_SUCCESS',
  FETCH_FEATURE_TOGGLES_FAILURE: 'FETCH_FEATURE_TOGGLES_FAILURE',
}
